// extracted by mini-css-extract-plugin
module.exports = {"list":"MatchingEntitiesList_list__28vtg","item":"MatchingEntitiesList_item__2yzSi"};